import React from 'react';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { CompetitorTable } from './components/CompetitorTable';
import { MarketPosition } from './components/MarketPosition';
import { StrategicQuadrant } from './components/StrategicQuadrant';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-[#0a1628] text-white selection:bg-[#00d4ff] selection:text-[#0a1628]" data-id="element-0">
      <Hero data-id="element-1" />
      <Features data-id="element-2" />
      <CompetitorTable data-id="element-3" />
      <MarketPosition data-id="element-4" />
      <StrategicQuadrant data-id="element-5" />
      <Pricing data-id="element-6" />
      <Footer data-id="element-7" />
    </main>;
}